import { Button } from '@/components/ui/button';
import { ExpiredRecoveryLinkProps } from './types';
import { Link } from 'react-router-dom';
import { RECOVERY_SUPPORT_EMAIL } from '../../../../model/recoverySupport';

const ExpiredRecoveryLink = (props: ExpiredRecoveryLinkProps) => {
  const { onGoToLogin } = props;

  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div
        className="flex size-16 items-center justify-center text-[hsl(var(--error-text))] rounded-full bg-[hsl(var(--error-bg))]"
        aria-hidden
      >
        <span className="font-sans text-[32px] font-semibold leading-none">!</span>
      </div>
      <div className="flex w-full flex-col items-center gap-3">
        <h1
          className="font-sans text-2xl font-semibold normal-case leading-8 tracking-normal text-foreground"
          aria-live="polite"
        >
          Ссылка больше не действует
        </h1>
        <p className="text-sm leading-5 text-muted-foreground">
          Ссылка недействительна или срок её действия истёк.
          {' '}Запросите новую ссылку для восстановления пароля.
        </p>
        <p className="text-sm leading-5 text-muted-foreground">
          Если восстановление уже началось, попробуйте войти или обратитесь в поддержку White Line:
          {' '}<a className="inline-block max-w-full break-words underline underline-offset-4" href={`mailto:${RECOVERY_SUPPORT_EMAIL}`}>
            {RECOVERY_SUPPORT_EMAIL}
          </a>.
        </p>
      </div>
      <div className="flex w-full flex-col gap-3">
        <Button
          className="w-full"
          asChild
          size="lg"
        >
          <Link to="/forgot-password">Запросить новую ссылку</Link>
        </Button>
        <Button
          className="w-full"
          onClick={onGoToLogin}
          type="button"
          variant="tertiary"
        >
          Вернуться ко входу
        </Button>
      </div>
    </div>
  );
};

export default ExpiredRecoveryLink;